
















import { Component, Prop, Vue } from "vue-property-decorator";
import { Party } from "@/types";
import { jitsiRoomUrl } from "@/utils/url";
import StreamIframe from "@/components/StreamIframe.vue";
import Navbar from "@/components/Navbar.vue";

@Component({
  components: {
    Navbar,
    StreamIframe,
  },
})
export default class JoinPartyPage extends Vue {
  @Prop({ required: true }) party!: Party;

  get jitsiRoomUrl(): string {
    return jitsiRoomUrl(this.party);
  }
}
